import { theme } from '@garnish/constants';
import React from 'react';
import { StyleSheet, ViewProps } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';

export const ScanToPayContainer = (props: ViewProps) => {
  return (
    <ScrollView contentContainerStyle={styles.container}>
      {props.children}
    </ScrollView>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flexGrow: 1,
    padding: theme.spacing['4'],
    gap: theme.spacing['4'],
  },
});
